// src/components/admin/AdminUtilisateurs.jsx — tous les comptes, rôles, blocage

import React, { useState } from "react";
import { getUtilisateurs, changerRole, basculerBlocage } from "../../services/AdminGestionService";
import { useListeAdmin, TableAdmin, Pagination, Recherche, Filtre, EnTete, Badge, Action, BoutonActualiser, dateFr } from "./AdminUI";

const COULEUR_ROLE = { admin: "rouge", createur: "violet", travailleur: "bleu" };

const AdminUtilisateurs = () => {
    const L = useListeAdmin(getUtilisateurs, { q: "", role: "", bloques: "" });
    const [message, setMessage] = useState(null);
    const roles = L.reponse?.roles || [];

    const agir = async (fn, confirmation) => {
        if (confirmation && !window.confirm(confirmation)) return;
        try {
            const r = await fn();
            setMessage({ ok: true, texte: r.message });
            L.recharger();
        } catch (e) {
            setMessage({ ok: false, texte: e.message });
        }
    };

    const colonnes = [
        { cle: "id", titre: "#", classe: "text-gray-400 text-xs" },
        { cle: "name", titre: "Utilisateur", rendu: (u) => (
            <div>
                <div className="font-semibold text-gray-900">{u.name || "—"}</div>
                <div className="text-[11px] text-gray-500">{u.email}</div>
            </div>
        )},
        { cle: "role", titre: "Rôle", rendu: (u) => (
            <select value={u.role || ""}
                onChange={(e) => agir(() => changerRole(u.id, e.target.value), `Passer ${u.email} en « ${e.target.value} » ?`)}
                className={`text-xs font-semibold rounded-lg border px-2 py-1 bg-white ${u.role === "admin" ? "border-red-200 text-red-700" : "border-gray-200 text-gray-700"}`}>
                {[...new Set([...roles, u.role])].filter(Boolean).map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
        )},
        { cle: "nb_evenements", titre: "Événements", classe: "text-center" },
        { cle: "nb_reservations", titre: "Réservations", classe: "text-center" },
        { cle: "stripe", titre: "Paiements", rendu: (u) =>
            u.role === "createur"
                ? (u.stripe_charges_enabled ? <Badge couleur="vert">Stripe actif</Badge> : <Badge couleur="orange">Non activé</Badge>)
                : <span className="text-gray-300">—</span>
        },
        { cle: "created_at", titre: "Inscrit le", rendu: (u) => <span className="text-xs text-gray-500">{dateFr(u.created_at)}</span> },
        { cle: "statut", titre: "Statut", rendu: (u) => u.bloque_at ? <Badge couleur="rouge">Bloqué</Badge> : <Badge couleur="vert">Actif</Badge> },
        { cle: "actions", titre: "", rendu: (u) => (
            <Action couleur={u.bloque_at ? "vert" : "rouge"}
                onClick={() => agir(() => basculerBlocage(u.id), u.bloque_at ? null : `Bloquer ${u.email} ? Il ne pourra plus se connecter.`)}>
                {u.bloque_at ? "Débloquer" : "Bloquer"}
            </Action>
        )},
    ];

    return (
        <div className="max-w-7xl mx-auto">
            <EnTete titre="Utilisateurs" sousTitre={`${L.page?.total ?? "…"} compte(s)`}
                actions={<>
                    <Recherche valeur={L.filtres.q} onChange={(v) => L.setFiltre("q", v)} placeholder="Nom ou e-mail…" />
                    <Filtre valeur={L.filtres.role} onChange={(v) => L.setFiltre("role", v)}
                        options={[["", "Tous les rôles"], ...roles.map((r) => [r, r])]} />
                    <Filtre valeur={L.filtres.bloques} onChange={(v) => L.setFiltre("bloques", v)}
                        options={[["", "Tous"], ["1", "Bloqués seulement"]]} />
                    <BoutonActualiser onClick={L.recharger} />
                </>}
            />

            {message && (
                <div className={`mb-4 px-4 py-2.5 rounded-xl text-sm border ${message.ok ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-700 border-red-200"}`}>
                    {message.texte}
                </div>
            )}

            <TableAdmin colonnes={colonnes} lignes={L.page?.data} loading={L.loading} erreur={L.erreur}
                ligneClasse={(u) => (u.bloque_at ? "bg-red-50/40" : "")} />
            <Pagination page={L.page} onPage={L.allerA} onParPage={L.setParPage} />
        </div>
    );
};

export default AdminUtilisateurs;